export default {
    pricing: {
        titleHK: '香港訂立平安紙服務 | 價目',
        descriptionHK: '單一份平安紙由 1,500 港元，夫妻各一份平安紙由 2,250 港元。 查看價目和網上平安紙服務有關的其他詳情。',
        keywordsHK: '香港平安紙費用,網上平安紙價錢,遺產計劃價格,會籍',
        whatIsThe: '平安紙的',
        pricing: '價格',
        forAWill: '',
        pricingStarts: '價格由',
        andIncludes: '起，修改費用由{{membership}}開始。',
        perJurisdiction: '每個司法管轄區',
        oneTimeBundlePrice: '一次性組合價格',
        forCouples: ' 夫妻組合',
        start: '免費開始',
        more: '關於網上平安紙',
        keep: '記得定時更新平安紙',
        upToDate: '',
        membership1:
            '生活環境變化無常，你的平安紙也應隨著時間而修改及更新。只需成為會員，便可隨時登入無限次修改你的平安紙。 對比起傳統的律師樓和平安紙公司所收的昂貴費用合理得多， 首年免費，其後每年{{price}}。',
        membership2: '',
        faq: '關於價格常見問題',
        package: '網上遺產計劃',
        onlineWills: '網上平安紙',
        onlineWill: '網上遺囑',
        onlineWillDescription: '只需 15 分鐘即可在網上訂立遺囑，並在需要時獲得指導。',
        estatePlanningBundle: '遺產規劃組合',
        estatePlanningBundleDescription: '包括專家遺產規劃諮詢、專業查閱、身份驗證，以及海外資產的額外指導。',
        temporaryGuardianshipDescription: '指定臨時監護人',
        whatsIncluded: '包含',
        availableAddons: '可選附加服務',
        idealFor: '適合',
        single: '單一份平安紙',
        couple: '夫婦各一份平安紙',
        willIncludes1: '1 份按司法管轄區訂立的平安紙文件',
        willIncludes2: '致執行人/受託人的信函（通知他們被委任了）',
        willIncludes3: '願望信',
        willIncludes4: '資產與數碼資產清單',
        willIncludes5: '所有文件的PDF版本',
        willIncludes6: '30日在平台上進行無限次更改',
        willIncludes7: '專業印刷版本送到府上',
        willIncludes8: '為您的平安紙和資產清單進行專業查閱',
        willIncludes9: '30分鐘網上遺產規劃諮詢與我們的遺囑專家',
        willIncludes10: '指定永久監護人',
        willIncludes11: '自行簽署見證指示',
        willIncludes12: '遺囑一致性審查',
        willIncludes13: '「網上遺囑」服務的所有內容',
        willIncludes14: '身份驗證',
        willIncludes15: '安排見證',
        willIncludes16: '海外資產及多項司法管轄權的額外指導',
        editingMembership: '會籍',
        membership: '會籍',
        membershipIncludes1: '無限次對您的平安紙進行修改',
        membershipIncludes2: '由我們的遺囑專家對每次的更新提交進行查閱',
        membershipIncludes3: '持續支援',
        membershipIncludes4: '通知您們有關的法律的變更。',
        witnessing: '見證服務',
        print: '專業印刷版本',
        storageService: '平安紙保管服務',
        countrySpecificWills: '其他國家平安紙',
        discount: '折扣',
        fixedDiscount: '扣減{{currency}}{{discount}}',
        percentDiscount: '{{discount}}%優惠',
        autoApply: '折扣將會自動在結帳時使用。',
        onlineWillFootnote: '如需要多於一個國家的平安紙，可另外加購其他國家的平安紙。',
        estatePlanningBundleFootnote: '遺產規劃組合是一次性套裝，包括一份平安紙及額外服務。其他國家的平安紙可另外加購。',
    },
};
